import { IOmniaSession } from "../types"
import { isImageContentType } from "../utils/utils"
import { ImportDocumentVm, ISize } from "./types"

export function getSizeInfo(session: IOmniaSession) {

    const setting = session.getSettings("import.document-library").getKey("list-size")
    const sizes: ISize[] = [{ id: 'small', name: 'Small' }, { id: 'medium', name: 'Medium' }, { id: 'large', name: 'Large' }]

    let size = setting.get()
    size = (size ? sizes.find(s => s.id == size) : null) || sizes[0]

    const create = (size: ISize) => ({
        sizes,
        size,
        setCurrent
    })

    const setCurrent = (id: string) => {

        const newSize = sizes.find(s => s.id == id) || size
        setting.set(newSize.id)

        return create(newSize)

    }

    return create(size)

}

export function getDocumentCssClass(size: ISize, doc: ImportDocumentVm) {
    const pdf = doc.document.ContentType == "application/pdf"
    return `document ${size.id} ${doc.selected ? "selected" : ""} ${pdf ? "pdf" : ""}`
}


export function filterDocuments({ documents, limitToPictures, search }: { documents: ImportDocumentVm[], limitToPictures: boolean, search: string }) {

    let docs = [...documents || []]

    if (limitToPictures) {
        docs = docs.filter(d => isImageContentType(d.document.ContentType))
    }

    if (search) {
        search = search.toLowerCase()
        docs = docs.filter(d => d.document.FileName.toLowerCase().indexOf(search) !== -1)
    }

    return docs

}

interface CanSelectArgs {
    documents: ImportDocumentVm[]
    documentSelection: boolean,
    multipleSelection: boolean
}

export function canSelectDocument(doc: ImportDocumentVm, { documents, documentSelection, multipleSelection }: CanSelectArgs): boolean {

    if (!doc) return false

    if (documents && documentSelection) {
        if (multipleSelection) return true
        const selected = documents.filter(d => d.selected)
        return ((selected.length < 1) || doc.selected)
    }

}
